export default "__VITE_ASSET__a947668e__"